// extracted by css-extract-rspack-plugin
export default {"default_button_override":"rhhFH","defaultButtonOverride":"rhhFH","#":"QFgl7","label_override":"mwOKV","labelOverride":"mwOKV"};